@if (dataSource.length > 0) {
<table mat-table [dataSource]="tableSource" matSort (matSortChange)="onSort($event)" class="mat-elevation-z8">

  <ng-container matColumnDef="tg">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="codigoOs">OS</th>
    <td mat-cell *matCellDef="let element">
      <b>{{ element.codigoOs }}</b>
    </td>
  </ng-container>

  <ng-container matColumnDef="data">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="data">Data</th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.cell-alterada]="campoAlterado(element, 'dataInicio', 'dataFinal')"
      [matTooltip]="tooltipAlteracao(element, 'dataInicio', 'dataFinal')"
      [matTooltipDisabled]="!campoAlterado(element, 'dataInicio', 'dataFinal')"
    >{{ element.data }}</td>
  </ng-container>

  <ng-container matColumnDef="horario">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="hora">Horário</th>
    <td mat-cell *matCellDef="let element">
      @if (element.horaInicio) {
        <b
          [class.cell-alterada]="campoAlterado(element, 'horaInicio')"
          [matTooltip]="tooltipAlteracao(element, 'horaInicio')"
          [matTooltipDisabled]="!campoAlterado(element, 'horaInicio')"
        >{{ element.horaInicio }}</b> →
        <b
          [class.cell-alterada]="campoAlterado(element, 'horaFinal')"
          [matTooltip]="tooltipAlteracao(element, 'horaFinal')"
          [matTooltipDisabled]="!campoAlterado(element, 'horaFinal')"
        >{{ element.horaFinal || '-' }}</b><br />
        <span class="text-xs text-gray-400">contratado</span>
        @if (element.horaTerminoReal) {
          <br />
          <span class="text-xs text-gray-700"><b>{{ element.horaTerminoReal }}</b> realizado</span>
        } @else {
          @if (element.horaTerminoPrevisto) {
            <br />
            <span class="text-xs text-gray-400">
              {{ element.horaTerminoPrevisto }} previsto
              @if (element.distanciaPrevistaKm != null) { · {{ element.distanciaPrevistaKm }} km }
            </span>
          }
          @if (element.origemPrevisao === 'indisponivel') {
            <br />
            <span class="chip chip-warning" matTooltip="Falta endereço de rua numa das pontas — não dá pra calcular a rota.">
              sem endereço cadastrado
            </span>
          } @else if (element.origemPrevisao === 'simulado') {
            <span class="chip chip-simulado" matTooltip="Estimativa gerada no servidor, sem Google — só aparece no ambiente de qa.">
              simulado
            </span>
          }
        }
      } @else {
        <span class="chip chip-warning" matTooltip="1.330 das 10.315 OS não têm hora de início cadastrada — sem âncora não há prazo, então as fases ficam pendentes até alguém confirmar.">
          sem hora de início
        </span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="cliente">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="cliente">Cliente</th>
    <td mat-cell *matCellDef="let element">
      <b>Cliente: </b>{{ element.cliente || '-' }}<br />
      <b>SubCliente: </b>{{ element.subCliente || '-' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="consultora">
    <th mat-header-cell *matHeaderCellDef>Consultora tg.mob</th>
    <td mat-cell *matCellDef="let element">{{ element.consultora?.nome || '-' }}</td>
  </ng-container>

  <ng-container matColumnDef="origem">
    <th mat-header-cell *matHeaderCellDef>Origem</th>
    <td mat-cell *matCellDef="let element">
      <span [matTooltip]="element.origem?.resumo || ''">{{ element.origem?.enderecoCompleto || element.origem?.resumo || '-' }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="destino">
    <th mat-header-cell *matHeaderCellDef>Destino</th>
    <td mat-cell *matCellDef="let element">
      <span [matTooltip]="element.destino?.resumo || ''">{{ element.destino?.enderecoCompleto || element.destino?.resumo || '-' }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="tipoServico">
    <th mat-header-cell *matHeaderCellDef>Tipo de serviço</th>
    <td mat-cell *matCellDef="let element">
      <b>{{ element.tipoServico || '-' }}</b><br />
      <span class="text-xs text-gray-500">{{ element.servico || '-' }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="veiculo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="veiculo">Veículo</th>
    <td
      mat-cell
      *matCellDef="let element"
      (click)="$event.stopPropagation()"
      [class.cell-alterada]="campoAlterado(element, 'veiculo')"
      [matTooltip]="tooltipAlteracao(element, 'veiculo')"
      [matTooltipDisabled]="!campoAlterado(element, 'veiculo')"
    >
      @if (element.veiculo?.placa) {
        {{ element.veiculo.categoria || '-' }}
      } @else {
        <span class="chip chip-danger">Não alocado</span><br />
        <button type="button" class="link-ver-mais" (click)="alterarVeiculo.emit(element)">alocar</button>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="motorista">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="motorista">Motorista</th>
    <td
      mat-cell
      *matCellDef="let element"
      (click)="$event.stopPropagation()"
      [class.cell-alterada]="campoAlterado(element, 'motorista')"
      [matTooltip]="tooltipAlteracao(element, 'motorista')"
      [matTooltipDisabled]="!campoAlterado(element, 'motorista')"
    >
      @if (element.motorista) {
        {{ element.motorista.nome }}
        @if (element.primeiroServicoMotorista) {
          <mat-icon class="icon-primeiro-servico" style="cursor: help;" [matTooltip]="element.avisoMotorista">info</mat-icon>
        }
        <br />
        {{ element.motorista.telefone | telefone }}
        <button
          type="button"
          mat-icon-button
          class="btn-icon-mensagem"
          matTooltip="Mandar mensagem ao motorista"
          (click)="mensagemMotorista.emit(element)"
        >
          <mat-icon>chat</mat-icon>
        </button>
      } @else {
        <span class="chip chip-danger">Não alocado</span><br />
        <button type="button" class="link-ver-mais" (click)="alterarMotorista.emit(element)">alocar</button>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="passageiro">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="totalPassageiros">Passageiro</th>
    <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
      @if (element.totalPassageiros > 0) {
        {{ element.passageiros[0]?.nome }}
        @if (element.totalPassageiros > 1) {
          <span class="chip-passengers">+{{ element.totalPassageiros - 1 }}</span>
        }
        <br />
        <a class="link-ver-mais" (click)="verPassageiros.emit(element)">Ver mais</a>
      } @else {
        <span class="text-gray-400">Sem passageiro</span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="farol">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="statusFarol">Farol · Fases do serviço</th>
    <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
      <farol-fases
        [farol]="element.farol"
        [agora]="agora"
        [noShow]="element.noShow"
        [envio]="element.envio"
        (confirmarFase)="onConfirmarFase(element, element.farol.fases[$event - 1])"
        (confirmarEnvio)="confirmarEnvio.emit(element)"
      />
    </td>
  </ng-container>

  <ng-container matColumnDef="acoes">
    <th mat-header-cell *matHeaderCellDef>Ações</th>
    <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
      @if (element.observacao) {
        <mat-icon class="btn-icon-outline" style="cursor: help;" [matTooltip]="element.observacao">speaker_notes</mat-icon>
      }
      <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Mais ações">
        <mat-icon class="btn-icon-outline">more_horiz</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="editarOs.emit(element)">
          <mat-icon>edit</mat-icon><span>Editar OS</span>
        </button>
        <button mat-menu-item (click)="alterarMotorista.emit(element)">
          <mat-icon>person</mat-icon><span>Alterar motorista</span>
        </button>
        <button mat-menu-item (click)="alterarVeiculo.emit(element)">
          <mat-icon>directions_car</mat-icon><span>Alterar veículo</span>
        </button>
        <button mat-menu-item (click)="ocorrencias.emit(element)">
          <mat-icon [ngClass]="element.temOcorrencia ? 'has-occurrence' : ''">report_problem</mat-icon>
          <span>Ocorrências</span>
        </button>
        <button mat-menu-item (click)="progresso.emit(element)">
          <mat-icon>timeline</mat-icon><span>Progresso do trajeto</span>
        </button>
        <button mat-menu-item (click)="historico.emit(element)">
          <mat-icon>history</mat-icon><span>Histórico</span>
        </button>
        @if (element.statusId === STATUS_OS_AGUARDANDO_CONFIRMACAO_OPERADOR) {
          <button mat-menu-item (click)="confirmarAtribuicao.emit(element)">
            <mat-icon>check_circle</mat-icon><span>Confirmar atribuição</span>
          </button>
          <button mat-menu-item (click)="recusarAtribuicao.emit(element)">
            <mat-icon>cancel</mat-icon><span>Recusar atribuição</span>
          </button>
        }
        @if (element.envio) {
          <button mat-menu-item (click)="desfazerEnvio.emit(element)">
            <mat-icon>undo</mat-icon><span>Desfazer confirmação de envio</span>
          </button>
        } @else {
          <button mat-menu-item (click)="confirmarEnvio.emit(element)">
            <mat-icon>send</mat-icon><span>Confirmar envio</span>
          </button>
        }
        @if (element.noShow) {
          <button mat-menu-item (click)="desmarcarNoShow.emit(element)">
            <mat-icon>undo</mat-icon><span>Desmarcar no-show</span>
          </button>
        } @else {
          <button mat-menu-item (click)="marcarNoShow.emit(element)">
            <mat-icon>block</mat-icon><span>Marcar no-show</span>
          </button>
        }
        @if (element.statusId !== STATUS_OS_CANCELADO && element.statusId !== STATUS_OS_CANCELADO_CONTRATO) {
          <button mat-menu-item (click)="cancelarOs.emit(element)">
            <mat-icon class="icon-danger">cancel</mat-icon><span>Cancelar OS</span>
          </button>
        }
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row class="style-row style-row--clickable" [ngClass]="rowClass(row)" *matRowDef="let row; columns: displayedColumns" (click)="editarOs.emit(row)"></tr>
</table>
} @else {
<div>
  <h3 class="text-center">Nenhum registro encontrado.</h3>
</div>
}
